import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { AuthProvider } from 'react-oidc-context';

import { oidcSettings } from '@bluesphere/identity-client';

import { configureApi } from '@bluesphere/api-client';
import { MdrPanelProvider } from '@bluesphere/mdr-alert-panel';

import { App } from './App';
import { clearLegacyStorage, identityConfig } from './auth/oidc';
import { SelectedTenantProvider } from './auth/useSelectedTenant';
import { mdrPanelHost } from './lib/mdrPanelHost';
import { queryClient } from './lib/queryClient';
import { router } from './router';

import './styles/index.css';

// Baked in at build time by scripts/deploy-web.sh from the integrations-api
// stack's output. The client refuses to run without it rather than calling
// a relative URL on the CloudFront origin.
configureApi({ baseUrl: import.meta.env.VITE_INTEGRATIONS_API_URL });

clearLegacyStorage();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <AuthProvider {...oidcSettings(identityConfig)}>
      <QueryClientProvider client={queryClient}>
        <MdrPanelProvider host={mdrPanelHost}>
          <App>
            <SelectedTenantProvider>
              <RouterProvider router={router} />
            </SelectedTenantProvider>
          </App>
        </MdrPanelProvider>
      </QueryClientProvider>
    </AuthProvider>
  </React.StrictMode>,
);
